import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

 
const Chart = ({exData}) => {

  const data = {
    labels: ['IDO', 'Locked', 'Liquidity', 'Unlocked', 'Burnt'],
    datasets: [
      { 
        data: exData,
        backgroundColor: [
          '#1AFC2E', 
          '#38B7FE', 
          '#FFFF00', 
          '#074BA0', 
          '#AF90F8', 
        ],
        borderColor: [
          '#1AFC2E', 
          '#38B7FE', 
          '#FFFF00', 
          '#074BA0', 
          '#AF90F8', 
        ],
        borderWidth: 1, 
      },
    ],
  };

    return <Doughnut 
    data={data}
    
      />;
  
}

export default Chart